import { render } from "./SocialCategory.vue?vue&type=template&id=192a9ad8&scoped=true"
import script from "./SocialCategory.vue?vue&type=script&lang=js"
export * from "./SocialCategory.vue?vue&type=script&lang=js"

import "./SocialCategory.vue?vue&type=style&index=0&id=192a9ad8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192a9ad8"]])

export default __exports__